import { Button, Icon, Typography } from "@storoey/sui";
import { onCleanup } from "solid-js";
import { formatRelativeDate } from "../../utils/format-relative-date";
import styles from "./AudioPlayback.module.scss";

interface AudioPlaybackProps {
  blob: Blob;
  date: Date;
  onDelete: () => void;
}

export const AudioPlayback = (props: AudioPlaybackProps) => {
  const audioUrl = URL.createObjectURL(props.blob);
  const relativeDate = formatRelativeDate(props.date);

  onCleanup(() => {
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
    }
  });

  return (
    <div class={styles["container"]}>
      <Typography variant="label">{relativeDate}</Typography>
      <div class={styles["content"]}>
        <audio src={audioUrl} controls />

        <Button
          size="medium"
          variant="ghost"
          color="red"
          leftIcon={<Icon>delete</Icon>}
          onClick={props.onDelete}
        ></Button>
      </div>
    </div>
  );
};
